import { z } from "zod";

/**
 * Converts input to number or null.
 * Treats "", null, or undefined as null.
 * Supports floats.
 */
export const nullableNumber = (invalidMessage?: string) =>
  z.preprocess(
    (val) => {
      if (val === "" || val === null || val === undefined) {
        return null;
      }

      return Number(val);
    },
    z
      .number({
        invalid_type_error: invalidMessage,
        required_error: invalidMessage,
      })
      .nullable()
  );
